export const inReducer = ['contact_organization', 'document']
